import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const MacronutrientsContainer = styled(Box)`
  display: flex;
  justify-content: space-around;
  width: 100%
  `;
